import { AttendanceEnumsPoolTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const getCompensationMethod = (poolType: AttendanceEnumsPoolTypeEnum) => {
  switch (poolType) {
    case 'timeoff':
      return i18n.t('time_tracking.settings.work_time_categories.special_work_hours.cell.time_off')
    case 'virtual_payroll':
    case 'payroll':
      return i18n.t('time_tracking.settings.work_time_categories.special_work_hours.cell.payroll')
    case 'balance':
      return i18n.t(
        'time_tracking.settings.work_time_categories.special_work_hours.cell.bank_of_hours'
      )
  }
}
